export enum MapColors {
  GOING = "#6ecc98",
  RETURNING = "#d0c151",
  ZMRC = "#FFA500"
}

export enum MapConfig {
  RADIUS = 80,
  VER_ZONE_BUFFER_DISTANCE = 7
}
